module.exports = __webpack_public_path__ + "img/Untereinsatzabschnittsleiter.bedffdd8.svg";